export const showHideSubscriptionModal = (accessToken, closeModal) => {
  if (closeModal) {
    closeModal()
  }
  // const domain = process.env.NODE_ENV === 'production' && process.env.__NOTIFICATION_ENV__ == 'production' ? 'basemap' : 'staging2.basemap'
  //  const domain = 'basemap'
  const domain = 'purchase.basemap'
  const env = process.env.NODE_ENV == 'dev' ? 'staging-purchase' : process.env.NODE_ENV == 'purchase' && process.env.__NOTIFICATION_ENV__ == 'dev' ? 'preprod' : 'purchase'

  // window.open(`https://www.${domain}.com/choose-subscription/?ref=internal&env=${env}&token=${accessToken}`)
  window.open(`https://${env}.basemap.com/?ref=webapp&token=${accessToken}`)
}